
import { EventsOnSaleResolver } from "./events-on-sale.resolver";
import { EventTicketsResolver } from "../components/event-tickets"
import { EventListResolver } from "../components/event-components/event-list"
import { EventFormResolver } from "../components/event-components/event-form"
import { SeatingplanResolver } from "../components/seatingplan-sale/seatingplan-sale.resolver";
import { BoxOfficeResolver } from "../components/box-office/box-office.resolver";

export { EventsOnSaleResolver,
	EventTicketsResolver,
	EventListResolver,
	EventFormResolver,
	SeatingplanResolver
};

export const APP_RESOLVER_PROVIDERS = [
	EventsOnSaleResolver,
	EventTicketsResolver,
	EventListResolver,
	EventFormResolver,
	SeatingplanResolver,
	BoxOfficeResolver
];



// WEBPACK FOOTER //
// ./src/app/resolver/index.ts